// lib
import { createAction } from "@reduxjs/toolkit";

// Network callbacks
export const searchRequest = createAction("search/request");
export const searchSuccess = createAction("search/success");
export const searchFailure = createAction("search/failure");
export const clearSearch = createAction("search/clear");
